// extracted by mini-css-extract-plugin
export default {"layoutContainer":"style_layoutContainer__ssx46","layoutContent":"style_layoutContent__rEFi+","pageContent":"style_pageContent__PTQV4"};